import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../hooks'

const CardsPlayMessageDisplay = () => {
  const message = useAppSelector(state => state.game.currentGame?.state.message || '')
  const [showMessage, setShowMessage] = useState(false)
  const [celebrationfadeOut, setCelebrationfadeOut] = useState(false)

  useEffect(() => {
    if (message) {
      setShowMessage(true)
      setCelebrationfadeOut(false)
      const fadeOutTimeout = setTimeout(() => setCelebrationfadeOut(true), 1300)
      const hideMessageTimeout = setTimeout(() => setShowMessage(false), 1500)
      return () => {
        clearTimeout(fadeOutTimeout)
        clearTimeout(hideMessageTimeout)
      }
    }
  }, [message])

  return (
    <>
      {showMessage && (
        <div className={`celebration ${celebrationfadeOut ? 'fade-out' : ''}`}>
          {message}
        </div>
      )}
    </>
  )
}

export default CardsPlayMessageDisplay